import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_TEST_CATEGORIES,
    getTestCategoriesFail,
    getTestCategoriesSuccess
} from '../action/getTestCategoriesAction'

// api 
import getTestCategoriesApi from '../api/getTestCategoriesApi'

export function* getTestCategoriesSaga(action) {
    try {
        const response = yield call(() => getTestCategoriesApi(action.params))
        if (response.data.statusCode === 200) {
            yield put(getTestCategoriesSuccess(response, action))
        } else {
            yield put(getTestCategoriesFail(response, action))
        }
    }
    catch (e) {
        yield put(getTestCategoriesFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_TEST_CATEGORIES, getTestCategoriesSaga)
}